exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.remote-wrapper[data-v-3c18eae6] {\n  width: 100%;\n  height: 100%;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/layout/pages/home/my-workbench/remote-wrapper.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd","file":"remote-wrapper.vue","sourcesContent":["\n.remote-wrapper[data-v-3c18eae6] {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c18eae6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/pages/home/my-workbench/remote-wrapper.vue
// module id = 81Wq
// module chunks = 6